// AUTO GENERATED FILE BY @kalissaac/prisma-typegen
// DO NOT EDIT

export enum Role {
  CHEF = 'CHEF',
  STUDENT = 'STUDENT',
  PARENT = 'PARENT',
  ADMIN = 'ADMIN',
}

export enum DishType {
  STARTER = 'STARTER',
  PROTEIN_DISH = 'PROTEIN_DISH',
  SIDE_DISH = 'SIDE_DISH',
  MIXED_DISH = 'MIXED_DISH',
  DAIRY_PRODUCT = 'DAIRY_PRODUCT',
  DESSERT = 'DESSERT',
}

export enum MenuType {
  FIVE_DISHES = 'FIVE_DISHES',
  FOUR_DISHES = 'FOUR_DISHES',
}

export enum EatingDay {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export enum Allergy {
  GLUTEN = 'GLUTEN',
  CRUSTACEAN = 'CRUSTACEAN',
  EGG = 'EGG',
  FISH = 'FISH',
  PEANUT = 'PEANUT',
  SOY = 'SOY',
  MILK = 'MILK',
  NUT = 'NUT',
  CELERY = 'CELERY',
  MUSTARD = 'MUSTARD',
  SESAME = 'SESAME',
  SULFITE = 'SULFITE',
  LUPINE = 'LUPINE',
  MOLLUSC = 'MOLLUSC',
  NONE = 'NONE',
}

export enum NutritionalScoreValue {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export enum DishChangedReason {
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  CHANGED_MY_MIND = 'CHANGED_MY_MIND',
}

export enum NoisePollutionValue {
  VERY_LOW = 'VERY_LOW',
  LOW = 'LOW',
  HIGH = 'HIGH',
  VERY_HIGH = 'VERY_HIGH',
}

export enum WasteValue {
  VERY_LOW = 'VERY_LOW',
  LOW = 'LOW',
  HIGH = 'HIGH',
  VERY_HIGH = 'VERY_HIGH',
}

export enum NotificationType {
  NEW_MEAL = 'NEW_MEAL',
  RATE_MEAL = 'RATE_MEAL',
}

export interface Entity {
  id: number;
  createdAt: Date;
  name: string;
  address: string;
  public: boolean;
  invitationCode: string;
  eatingDays: EatingDay[];
  members: User[];
  foods: Food[];
  dishes: Dish[];
  menus: Menu[];
  meals: Meal[];
  invitationTokens: Token[];
}

export interface User {
  id: number;
  email?: string;
  username?: string;
  firstName: string;
  lastName: string;
  birthDate?: Date;
  createdAt: Date;
  confirmed: boolean;
  password: string;
  roles: Role[];
  entity: Entity;
  entityId: number;
  resetPasswordToken?: Token;
  refreshToken?: string;
  parent?: Parent;
  parentId?: number;
  student?: Student;
  studentId?: number;
}

export interface Parent {
  id: number;
  childrens: Student[];
  userId: number;
  user: User;
}

export interface Student {
  id: number;
  class: string;
  parent?: Parent;
  parentId?: number;
  userId: number;
  user: User;
  preference?: Preference;
  eatingDays: EatingDay[];
  allergies: Allergy[];
  dishRates: DishRate[];
  menuVotes: StudentMenuVote[];
  absences: Meal[];
  noisePollutionRates: NoisePollutionRate[];
  notifications: Notification[];
}

export interface Notification {
  id: number;
  createdAt: Date;
  type: NotificationType;
  active: boolean;
  student?: Student;
  studentId?: number;
  meal?: Meal;
  mealId?: number;
}

export interface OnboardingDish {
  id: number;
  name: string;
  type: DishType;
  preferenceOnboardingDish: PreferenceOnboardingDish[];
  preferenceOnboardingMenuDish: PreferenceOnboardingMenuDish[];
}

export interface PreferenceOnboardingDish {
  id: number;
  position: number;
  type: DishType;
  dish: OnboardingDish;
  dishId: number;
  preference: Preference;
  preferenceId: number;
}

export interface PreferenceOnboardingMenuDish {
  id: number;
  selected: boolean;
  dish: OnboardingDish;
  dishId: number;
  preferenceOnboardingMenu: PreferenceOnboardingMenu;
  preferenceOnboardingMenuId: number;
}

export interface PreferenceOnboardingMenu {
  id: number;
  dishes: PreferenceOnboardingMenuDish[];
  preference: Preference;
  preferenceId: number;
}

export interface Preference {
  id: number;
  student: Student;
  studentId: number;
  aroma?: number;
  appearance?: number;
  quantity?: number;
  temperature?: number;
  dishes: PreferenceOnboardingDish[];
  dishesCompleted: boolean;
  menus: PreferenceOnboardingMenu[];
  menusCompleted: boolean;
}

export interface Token {
  id: number;
  token: string;
  createdAt: Date;
  user?: User;
  userId?: number;
  entity?: Entity;
  entityId?: number;
}

export interface File {
  id: number;
  createdAt: Date;
  name: string;
  url: string;
  key: string;
  food: Food[];
  dish: Dish[];
  dishDocument?: Dish;
  dishDocumentId?: number;
}

export interface Food {
  id: number;
  name: string;
  deleted: boolean;
  description: string;
  seasonality?: string;
  origin?: string;
  nutritionalIntake?: string;
  benefits?: string;
  image?: File;
  imageId?: number;
  dishes: Dish[];
  entity: Entity;
  entityId: number;
}

export interface NutritionalScore {
  id: number;
  createdAt: Date;
  calories: NutritionalScoreValue;
  benefits: NutritionalScoreValue;
  carbonFootprint: NutritionalScoreValue;
  transformation: NutritionalScoreValue;
  dish?: Dish;
}

export interface DishRate {
  id: number;
  createdAt: Date;
  aroma: number;
  aromaReason?: string;
  appearance: number;
  appearanceReason?: string;
  quantity: number;
  quantityReason?: string;
  temperature: number;
  temperatureReason?: string;
  dishChangedReason?: DishChangedReason;
  dish: Dish;
  dishId: number;
  meal: Meal;
  mealId: number;
  student: Student;
  studentId: number;
}

export interface StudentMenuVote {
  id: number;
  createdAt: Date;
  student: Student;
  studentId: number;
  dishes: Dish[];
  meal: Meal;
  mealId: number;
}

export interface Dish {
  id: number;
  createdAt: Date;
  name: string;
  deleted: boolean;
  menus: Menu[];
  type: DishType;
  allergens: Allergy[];
  dishRates: DishRate[];
  studentsMenuVotes: StudentMenuVote[];
  foods: Food[];
  entity: Entity;
  entityId: number;
  documents: File[];
  nutritionalScore: NutritionalScore;
  nutritionalScoreId: number;
  image?: File;
  imageId?: number;
}

export interface Menu {
  id: number;
  createdAt: Date;
  name: string;
  deleted: boolean;
  type: MenuType;
  dishes: Dish[];
  meals: Meal[];
  entity: Entity;
  entityId: number;
}

export interface NoisePollutionRate {
  id: number;
  createdAt: Date;
  rate: NoisePollutionValue;
  student: Student;
  studentId: number;
  meal: Meal;
  mealId: number;
}

export interface Meal {
  id: number;
  createdAt: Date;
  published: boolean;
  date: Date;
  day: EatingDay;
  publicHoliday: boolean;
  menu?: Menu;
  menuId?: number;
  entity: Entity;
  entityId: number;
  weather?: Weather;
  studentsVotes: StudentMenuVote[];
  absences: Student[];
  dishRates: DishRate[];
  noisePollutionRates: NoisePollutionRate[];
  notifications: Notification[];
}

export interface Weather {
  id: number;
  totalWaste?: number;
  totalParticipants?: number;
  wasteValue?: WasteValue;
  noisePollutionValue?: NoisePollutionValue;
  meal: Meal;
  mealId: number;
}
